export const colors = {
  orange: '#ffa500',
  red: '#FF0D10',
  yellow: '#ffbf00',
  lightGray: '#ECECEC',
  mediumLightGray: '#cdcccc',
  strongGray: '#808080',
  mediumGray: '#A7ACB3',
  black: '#000',
  fb_blue: '#4267B2',
  white: '#FFFFFF',
  cardinalRed: '#5A110D',
  cardinalRedLogo: '#bb0d03',
  blue: '#2E6CF6',
  lightBlue: '#c4e0f5',
  green: '#39CC64',
  blueTheme: '#002952',
  tooltipBG: '#D9D9D9',
  tooltipText: '#858790',
  navBarBackground: '#F6F6F8',
  darkGray: '#565657',
  principalTextColorTheme: '#FF0D10',
  brown: '#595959'
};
